import { render, staticRenderFns } from "./journal-main.vue?vue&type=template&id=161f4ac5"
import script from "./journal-main.vue?vue&type=script&lang=js"
export * from "./journal-main.vue?vue&type=script&lang=js"
import style0 from "./journal-main.vue?vue&type=style&index=0&id=161f4ac5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports